import Vue from 'vue'
import striptags from 'striptags'
import { decode } from 'html-entities'
import { Decimal } from 'decimal.js-light'
import moment from 'moment'

export default ({ store }) => {

  function stripAccents (s) {
    var inChrs = 'àáâãäçèéêëìíîïñòóôõöùúûüýÿÀÁÂÃÄÇÈÉÊËÌÍÎÏÑÒÓÔÕÖÙÚÛÜÝ'
    var outChrs = 'aaaaaceeeeiiiinooooouuuuyyAAAAACEEEEIIIINOOOOOUUUUY'
    var charsRgx = new RegExp('[' + inChrs + ']', 'g')
    var transl = {}
    var i
    var lookup = function (m) { return transl[m] || m }
    for (i = 0; i < inChrs.length; i++) {
      transl[inChrs[i]] = outChrs[i]
    }
    return s.replace(charsRgx, lookup)
  }
  function makeUrl (item, field) {
    if (!field) {
      field = 'id'
    }
    var s = item.name || ''
    s = stripAccents(s.toLowerCase())
    s = s.replace(/[\s:;,.]+/g, '-')
    s = s.replace(/[^0-9a-zA-Z-]/ig, '')
    s = s.replace(/-+/g, '-')
    s = s.replace(/-+$/g, '')
    return item[field] + (item.shopid ? '-' + item.shopid : '') + '-' + s
  }

  Vue.filter('makeUrl', function (shopId, locale, category, product) {
    return '/' + locale + (category ? '/categories/' + makeUrl(category) : '') + (product ? '/products/' + makeUrl(product, 'source_id') : '')
  })

  Vue.filter('makePageUrl', function (shopId, locale, page) {
    return '/' + locale + '/pages/' + makeUrl(page)
  })

  Vue.filter('urlDecode', function (val) {
    val = val.replace(/\+/g, '%20')
    var str = val.split('%')
    var cval = str[0]
    for (var i = 1; i < str.length; i++) {
      cval += String.fromCharCode(parseInt(str[i].substring(0, 2), 16)) + str[i].substring(2)
    }
    return cval
  })

  Vue.filter('externalLink', function (url) {
    if (url && url.match && !url.match(/:\/\//)) {
      return 'http://' + url
    }
    return url
  })

  Vue.filter('currency', function (amount, currency, decimals) {
    if (store.getters && store.getters.numberFormat === 'en-US') {
      return getCurrencySymbol(currency) + num(amount, decimals, '.', ',')
    } else {
      return num(amount, decimals, ',', ' ') + ' ' + getCurrencySymbol(currency)
    }
  })

  Vue.filter('num', function (amount, precision, forceDecimals = true) {
    if (!precision) {
      precision = 2
    }
    if (forceDecimals) {
      if (store.getters && store.getters.numberFormat === 'en-US') {
        return num(amount, precision, '.', ',')
      } else {
        return num(amount, precision, ',', ' ')
      }
    } else {
      if (store.getters && store.getters.numberFormat === 'en-US') {
        return notPaddedNum(amount, precision, '.', ',')
      } else {
        return notPaddedNum(amount, precision, ',', ' ')
      }
    }
  })

  Vue.filter('marketingname', function (product) {
    return (parseInt(product.usemarketingname) && product.marketingname ? product.marketingname : product.name)
  })

  Vue.filter('posname', function (product) {
    const posname = (parseInt(product.usemarketingname) && product.marketingname ? product.marketingname : product.name)
    const totalLength = posname.length + product.name.length
    return posname !== product.name && totalLength < 50 ? product.name + ' (' + posname + ')' : posname
  })

  function notPaddedNum(n, d = 2, s = ',', t = ' ') {
    n = typeof n === 'string' ? n.replace(',', '.') : n
    return parseFloat(new Decimal(isNaN(parseFloat(n)) ? 0 : n).toFixed(d).toString()).toString().replace('.', s).replace(/\B(?=(\d{3})+(?!\d))/g, t)
  }

  function num(n, d = 2, s = ',', t = ' ') {
    n = typeof n === 'string' ? n.replace(',', '.') : n
    return new Decimal(isNaN(parseFloat(n)) ? 0 : n).toFixed(d).replace('.', s).replace(/\B(?=(\d{3})+(?!\d))/g, t)
  }

  function getCurrencySymbol (val) {
    let symbols = {
      'EUR': '€',
      'USD': '$',
      'AUD': '$',
      'BRL': 'R$',
      'CAD': '$',
      'CRC': '₡',
      'CZK': 'Kč',
      'DKK': 'kr',
      'HKD': '$',
      'HUF': 'Ft',
      'ILS': '₪',
      'JPY': '¥',
      'MYR': 'RM',
      'MXN': '$',
      'NOK': 'kr',
      'NZD': '$',
      'PHP': '₱',
      'PLN': 'zł',
      'GBP': '£',
      'RUB': '₽',
      'SGD': '$',
      'SEK': 'kr',
      'CHF': 'CHF',
      'TWD': 'NT$',
      'THB': '฿'
    }
    if(!val) {
      val = 'EUR' // default to euros
    }
    return symbols[val] || val
  }

  Vue.filter('currencySymbol', getCurrencySymbol)

  Vue.filter('striptags', function (val) {
    return striptags(val)
  })

  Vue.filter('addDashes', function (val) {
    return val.match(/.{1,4}/g).join('-')
  })

  Vue.filter('toShortDate', function (val, locale) {
    let sd = new Date(val)
    if (locale === 'en') {
      return (sd.getMonth() + 1) + '/' + sd.getDate()
    } else {
      return sd.getDate() + '.' + (sd.getMonth() + 1) + '.'
    }
  })

  Vue.filter('toDate', function (val, locale) {
    if (store.getters && store.getters.dateFormat) {
      return moment(val).format(store.getters.dateFormat)
    }
    let d = new Date(val)
    if (locale === 'en') {
      return d.getFullYear() + '/' + (d.getMonth() + 1 < 10 ? '0' : '') + (d.getMonth() + 1) + '/' + (d.getDate() + 1 < 10 ? '0' : '') + d.getDate()
    } else {
      return d.getDate() + '.' + (d.getMonth() + 1) + '.' + d.getFullYear()
    }
  })

  Vue.filter('toTime', function (val, locale) {
    if (store.getters && store.getters.timeFormat) {
      return moment(parseInt(val)).format(store.getters.timeFormat)
    }
    function hours12 (date) {
      return (date.getHours() + 24) % 12 || 12
    }
    let d = new Date(parseInt(val))
    if (locale === 'en') {
      return hours12(d) + '.' + (d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()) + ' ' + (d.getHours() < 12 ? 'AM' : 'PM')
    } else {
      return d.getHours() + '.' + (d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes())
    }
  })

  Vue.filter('timestampToDate', function (val, locale) {
    if (isNaN(parseInt(val))) {
      return ''
    }
    let d = new Date(parseInt(val) * 1000)
    if (store.getters && store.getters.dateFormat) {
      return moment(d).format(store.getters.dateFormat)
    }
    if (locale === 'en') {
      return d.getFullYear() + '/' + (d.getMonth() + 1 < 10 ? '0' : '') + (d.getMonth() + 1) + '/' + (d.getDate() + 1 < 10 ? '0' : '') + d.getDate()
    } else {
      return d.getDate() + '.' + (d.getMonth() + 1) + '.' + d.getFullYear()
    }
  })

  Vue.filter('timestampToTime', function (val, locale) {
    function hours12 (date) {
      return (date.getHours() + 24) % 12 || 12
    }
    let d = new Date(parseInt(val) * 1000)
    if (store.getters && store.getters.timeFormat) {
      return moment(d).format(store.getters.timeFormat)
    }
    if (locale === 'en') {
      return hours12(d) + '.' + (d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()) + ' ' + (d.getHours() < 12 ? 'AM' : 'PM')
    } else {
      return d.getHours() + '.' + (d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes())
    }
  })

  Vue.filter('htmlentities', function (val) {
    return decode(val)
  })

  Vue.filter('truncate', function (text, length, clamp) {
    clamp = clamp || '...'
    length = length || 30

    if (text.length <= length) return text

    let tcText = text.slice(0, length - clamp.length)
    let last = tcText.length - 1

    while (last > 0 && tcText[last] !== ' ' && tcText[last] !== clamp[0]) last -= 1

    // Fix for case when text dont have any `space`
    last = last || length - clamp.length

    tcText = tcText.slice(0, last)

    return tcText + clamp
  })

}